import { ImageIcon } from "lucide-react";

interface NoImagePlaceholderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  text?: string;
}

export function NoImagePlaceholder({ 
  className = "", 
  size = "md", 
  text = "No Image" 
}: NoImagePlaceholderProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-16 h-16", 
    lg: "w-24 h-24"
  };

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div className={`${sizeClasses[size]} bg-gray-200 dark:bg-gray-700 flex flex-col items-center justify-center ${className}`}>
      <ImageIcon className={`${iconSizes[size]} text-gray-400 dark:text-gray-500 mb-1`} />
      <span className="text-xs text-gray-400 dark:text-gray-500 text-center px-1">
        {text}
      </span>
    </div>
  );
}
